import MyWorkProto from "./my-work-proto"
import {MY_WORK_ITEM_MEETING} from "./my-work-types"
import Meeting from "../meeting/meeting";

export default class MyWorkMeeting extends MyWorkProto {

    protected meeting       : Meeting

    constructor(meeting:Meeting) {
        super()

        this.meeting = meeting
    }

    get title() {
        return this.meeting.name
    }

    get isPastdue() {
        return false
        // return this.meeting.isPastdue
    }

    get canChangeDate() {
        // heh... tut esli i delat' to allow toka esli ti blin organizer a tak chere item view...
        return false
    }

    get myWorkId() {
        return this.meeting.rid
    }
    get myWorkType() {
        return MY_WORK_ITEM_MEETING
    }
    get fromUserId() {
        // bred net takogo field ze...
        // @ts-ignore
        return this.meeting.createdByUserId
    }

    get dateCreated() {
        // to fix nado...
        return momentDate()
    }


    get startDate() { return this.meeting.startMoment }
    get endDate() { return this.meeting.endMoment }

    get startMoment() { return this.meeting.startMoment }
    get endMoment() { return this.meeting.endMoment }


}
